import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import NotesSettingsConstants from 'bundles/account-settings/constants/NotesSettingsConstants';

const userNoteGlobalSettings = API('/api/userNoteGlobalSettings.v1/', { type: 'rest' });

const UserNoteGlobalSettingsAPIUtils = {
  getUserNoteGlobalSettings({ userId }: { userId: string }) {
    const uri = new URI(userId);
    return Q(userNoteGlobalSettings.get(uri.toString()));
  },

  updateUserNoteGlobalSettings({
    userId,
    disableDataAggregation,
    disableTopHighlightsDisplay,
  }: {
    userId: string;
    disableDataAggregation: boolean;
    disableTopHighlightsDisplay: boolean;
  }) {
    const uri = new URI(userId);

    const data: any = {
      disableDataAggregation: [],
      disableDisplay: [],
    };

    if (disableDataAggregation) {
      data.disableDataAggregation.push(
        NotesSettingsConstants.disableDataAggregation.NOTE_TEXT,
        NotesSettingsConstants.disableDataAggregation.VIDEO_NOTE_PROPERTIES
      );
    }

    if (disableTopHighlightsDisplay) {
      data.disableDisplay.push(NotesSettingsConstants.disableTopHighlightsDisplay.POPULAR_HIGHLIGHTS);
    }

    return Q(userNoteGlobalSettings.put(uri.toString(), { data }));
  },
};

export default UserNoteGlobalSettingsAPIUtils;
